import styled, { css } from 'styled-components'

import { Container as Card } from '~/components/Card/styles'

export const Container = styled(Card).attrs({
    className: 'box-link no-responsive'
})`
	padding: 0;
	width: 260px;

	@media(max-width: 600px) {
		width: calc(100% - 16px);
	}

	> a,
	> div {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 100%;
		padding: 45px 30px 30px;
		border-radius: 12px;

		h1 {
			margin-bottom: 15px;	
			font-size: 18px;
			color: #fff;
			text-align: center;
		}

		svg {
			margin-bottom: 12px;
			transition: 300ms;
			color: #fff;
		}

		&:hover {
			color: #fff;
			opacity: 1;

			svg {
				transform: translateY(-6px);
			}
		}

		.subdescricao {
			color: #fffa;
			font-size: 12px;
			text-align: center;
		}
	}

	${props => props.disabled && css`
		opacity: 0.5 !important;

		> a,
		> div {
			cursor: default;

			&:hover {
				svg {
					transform: unset;
				}
			}
		}
	`}
`
